import { FormattedMessage } from 'react-intl';
import { twMerge } from 'tailwind-merge';

import { CopyIcon } from '../../components/CopyIcon';
import { Chevron } from '../../components/layout/Chevron';
import { Link } from '../../components/Link';
import { RefreshButton } from '../../components/RefreshButton';
import { ReactComponent as IconChatDots } from '../../icons/icon-chats-dots.svg';
import type { Topic } from '../../types/api';
import type { YakliDiscussionProps } from './YakliDiscussion';
import { yakliMessages } from './yakliMessages';

type YakliHeaderProps = YakliDiscussionProps & {
  topic: Topic;
  forceRefetch: () => void;
};

// If Yakli Discussion is displayed as a modal, the choice has been made to disable links to subject page (cause the modale has pop from this very page, so no point to go back to it)

export const YakliHeader = ({
  slug,
  topic,
  messageId,
  forceRefetch,
  isModalDisplay = false,
}: YakliHeaderProps) => {
  return (
    <div className="flex flex-col items-center text-center mb-6">
      <h2 className="mb-2 text-lg justify-center text-primary font-normal md:font-semibold flex space-x-3 items-center">
        <IconChatDots className="hidden md:block" />
        <span>Fil de discussion</span>
        <RefreshButton
          className="self-center"
          iconContainerClassName="self-center"
          verticalAlign={null}
          refreshAction={forceRefetch}
        />
      </h2>
      <h3 className="font-normal text-base2">
        <FormattedMessage {...yakliMessages.subtitlePrefix} />{' '}
        <Link to={'topic'} params={{ slug }} disabled={isModalDisplay}>
          <a>
            <em>
              “
              <span className={twMerge('font-bold', !isModalDisplay && 'underline')}>
                {topic.subject}
              </span>
              ”
            </em>
          </a>
        </Link>
      </h3>
      <hr className="w-[110px] my-6 border-gray-280" />
      <div className="flex justify-center items-center gap-4 flex-wrap">
        {!isModalDisplay && (
          <div
            className={twMerge('flex items-center gap-4', isModalDisplay && 'text-gray-lightv4')}
          >
            <Link to={'topic'} params={{ slug, from: 'bubbleFlow' }} disabled={isModalDisplay}>
              <a className={twMerge(!isModalDisplay && 'underline')}>
                <FormattedMessage {...yakliMessages.allDiscussions} />
              </a>
            </Link>
            <Chevron />
          </div>
        )}
        <div className="flex space-x-2 items-center">
          <span>
            <FormattedMessage {...yakliMessages.uniqueDiscussion} />
          </span>
          <div className="flex bg-gray-50 rounded-lg min-w-[140px] justify-center">
            <CopyIcon messageId={messageId} slug={slug} />
          </div>
        </div>
      </div>
    </div>
  );
};
